import appConfig from "../../../config";

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export function noticeLogger(...params: any[]) {
    if (appConfig.notice) {
        // eslint-disable-next-line
        console.log(...params);
    }
}
